module.exports = "/_next/static/images/IlloUseCaseBoostCrossSellHover-be38aec12bb3cbd0fb50728c9caa9a89.png";